/* ========================================================================
   elate base theme JS
   Mobile menu drawer, cart drawer, sticky ATC scroll reveal, cart count.
   ======================================================================== */

(function () {
  'use strict';

  const body = document.body;
  const overlay = document.querySelector('[data-drawer-overlay]');

  function openDrawer(target) {
    const drawer = document.querySelector(target);
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    body.classList.add('no-scroll');
  }

  function closeAllDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach((d) => d.classList.remove('is-open'));
    if (overlay) overlay.classList.remove('is-open');
    body.classList.remove('no-scroll');
  }

  document.addEventListener('click', function (e) {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-drawer-overlay]')) {
      e.preventDefault();
      closeAllDrawers();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDrawers();
  });

  const stickyAtc = document.querySelector('[data-sticky-atc]');
  if (stickyAtc) {
    const threshold = 400;
    const onScroll = () => {
      const visible = window.scrollY > threshold;
      stickyAtc.classList.toggle('is-visible', visible);
      stickyAtc.inert = !visible; // keep the off-screen button out of the tab order
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // On the product's own page the bar scrolls back up to the buy box.
    const scrollLink = stickyAtc.querySelector('[data-sticky-scroll]');
    const buyBox = document.querySelector('[data-product-form]');
    if (scrollLink && buyBox) {
      scrollLink.addEventListener('click', (e) => {
        e.preventDefault();
        buyBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  window.refreshCartCount = function () {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.toggleAttribute('hidden', cart.item_count === 0);
        });
        return cart;
      })
      .catch(() => null);
  };

  document.addEventListener('DOMContentLoaded', window.refreshCartCount);

  /* ---- PDP: variant + plan + qty + ATC --------------------------------- */

  function moneyFormat(cents) {
    const value = (cents / 100).toFixed(2);
    return '£' + value;
  }

  function getProductData(form) {
    const section = form.closest('[data-product-section]');
    if (!section) return null;
    const json = section.querySelector('[data-product-json]');
    if (!json) return null;
    try { return JSON.parse(json.textContent); } catch (e) { return null; }
  }

  function getSelectedVariant(form, productData) {
    const optionInputs = form.querySelectorAll('[data-option-value]:checked');
    if (!productData) return null;
    if (optionInputs.length === 0) {
      return productData.variants.find(function (v) { return v.available; }) || productData.variants[0];
    }
    const selected = Array.from(optionInputs).map(function (i) { return i.value; });
    return productData.variants.find(function (v) {
      return v.options.every(function (opt, idx) { return opt === selected[idx]; });
    });
  }

  function updatePdpPrice(form) {
    const productData = getProductData(form);
    if (!productData) return;
    const variant = getSelectedVariant(form, productData);
    if (!variant) return;

    const planInput = form.querySelector('[data-plan]:checked');
    const planId = planInput ? planInput.value : '';

    let displayCents = variant.price;
    if (planId) {
      const allocation = (variant.selling_plan_allocations || [])
        .find(function (a) { return String(a.selling_plan_id) === String(planId); });
      if (allocation) displayCents = allocation.price;
    }
    // Bundle tiles: displayed total comes from the tile (a cart-level automatic
    // discount sets the real charge), not from the variant unit price.
    if (planInput && planInput.getAttribute('data-price-override')) {
      displayCents = parseInt(planInput.getAttribute('data-price-override'), 10) || displayCents;
    }

    // Price element lives OUTSIDE the form (sibling, both inside .pdp__info-sticky).
    // Search at the section level so we find it.
    const section = form.closest('[data-product-section]') || document;
    const amountEl = section.querySelector('[data-price-amount]');
    if (amountEl) amountEl.textContent = moneyFormat(displayCents);

    const idInput = form.querySelector('[data-variant-id]');
    if (idInput) idInput.value = variant.id;

    const atc = form.querySelector('[data-atc]');
    const label = form.querySelector('[data-atc-label]');
    if (atc && label) {
      if (variant.available) {
        atc.disabled = false;
        label.textContent = 'add to bag';
      } else {
        atc.disabled = true;
        label.textContent = 'sold out';
      }
    }

    if (variant.id) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  document.addEventListener('change', function (e) {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (e.target.matches('[data-option-value]') || e.target.matches('[data-plan]')) {
      updatePdpPrice(form);
    }
  });

  document.addEventListener('click', function (e) {
    const stepBtn = e.target.closest('[data-qty-step]');
    if (!stepBtn) return;
    const form = stepBtn.closest('[data-product-form]');
    if (!form) return;
    const input = form.querySelector('[data-qty-input]');
    if (!input) return;
    const step = parseInt(stepBtn.getAttribute('data-qty-step'), 10) || 0;
    const next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
    input.value = next;

    // If a one-time tile is selected and a bundle tile matches the new quantity,
    // activate it so tile, qty and displayed price stay coherent. Never switches
    // away from a subscription tier.
    const sec = form.closest('[data-product-section]');
    const active = sec && sec.querySelector('.pdp__plan.is-active');
    if (active && !(active.getAttribute('data-plan-value') || '')) {
      const match = sec.querySelector('.pdp__plan[data-plan-value=""][data-qty-set="' + next + '"]');
      if (match && match !== active) match.click();
    }
  });

  function refreshCartDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const html = data && data['cart-drawer'];
        if (!html) return;
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const newDrawer = tmp.querySelector('#CartDrawer');
        const oldDrawer = document.querySelector('#CartDrawer');
        if (newDrawer && oldDrawer) {
          const wasOpen = oldDrawer.classList.contains('is-open');
          oldDrawer.replaceWith(newDrawer);
          if (wasOpen) newDrawer.classList.add('is-open');
        }
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    const atc = form.querySelector('[data-atc]');
    const msg = form.querySelector('[data-form-msg]');
    if (atc) { atc.classList.add('is-loading'); atc.disabled = true; }
    if (msg) { msg.textContent = ''; msg.classList.remove('is-success', 'is-error'); }

    const fd = new FormData(form);

    // Make the submitted plan authoritative to the VISIBLE selection (the active
    // tile), not the underlying radio. Guards against a subscription app (Seal)
    // resetting/removing the radios after the theme set its default, which would
    // otherwise drop the plan and add the item as one-time.
    const activeTile = form.querySelector('.pdp__plan.is-active');
    if (activeTile) {
      const planVal = activeTile.getAttribute('data-plan-value') || '';
      if (planVal) { fd.set('selling_plan', planVal); }
      else { fd.delete('selling_plan'); }
    }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: fd,
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw d; });
        return res.json();
      })
      .then(function () {
        return Promise.all([refreshCartDrawer(), window.refreshCartCount && window.refreshCartCount()]);
      })
      .then(function () {
        const drawer = document.querySelector('#CartDrawer');
        if (drawer) drawer.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        body.classList.add('no-scroll');
      })
      .catch(function (err) {
        const text = (err && (err.description || err.message)) || 'add to cart failed.';
        if (msg) { msg.textContent = text.toLowerCase(); msg.classList.add('is-error'); }
      })
      .finally(function () {
        if (atc) { atc.classList.remove('is-loading'); atc.disabled = false; }
      });
  });

  /* ---- Cart drawer: quantity change + remove --------------------------- */
  function cartChange(lineKey, quantity, drawer) {
    if (drawer) drawer.classList.add('is-busy');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return Promise.all([refreshCartDrawer(), window.refreshCartCount && window.refreshCartCount()]);
      })
      .catch(function () {})
      .finally(function () { if (drawer) drawer.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty]');
    var rmBtn = e.target.closest('[data-cart-remove]');
    if (!qtyBtn && !rmBtn) return;
    e.preventDefault();
    var drawer = document.querySelector('#CartDrawer');
    if (drawer && drawer.classList.contains('is-busy')) return; // a change is already in flight
    var key, qty;
    if (qtyBtn) {
      key = qtyBtn.getAttribute('data-line-key');
      var line = qtyBtn.closest('[data-cart-line]');
      var valEl = line && line.querySelector('[data-line-qty]');
      var cur = valEl ? (parseInt(valEl.textContent, 10) || 0) : 0;
      qty = qtyBtn.getAttribute('data-cart-qty') === 'inc' ? cur + 1 : cur - 1;
      if (qty < 0) { qty = 0; }
    } else {
      key = rmBtn.getAttribute('data-line-key');
      qty = 0;
    }
    if (!key) return;
    cartChange(key, qty, drawer);
  });

  /* ---- Klaviyo subscribe ---------------------------------------------- */
  /* Submits to Klaviyo's public client subscriptions endpoint using the
     company public API key. No server proxy required. */

  const KLAVIYO_REVISION = '2024-10-15';

  function setMsg(form, text, kind) {
    const msg = form.querySelector('[data-msg]');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.remove('is-success', 'is-error');
    if (kind) msg.classList.add('is-' + kind);
  }

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('[data-klaviyo-form]');
    if (!form) return;
    e.preventDefault();

    const email = (form.querySelector('input[type="email"]') || {}).value;
    const firstNameRaw = (form.querySelector('input[name="first_name"]') || {}).value || '';
    const firstName = firstNameRaw.trim();
    const listId = form.getAttribute('data-list-id');
    const companyId = form.getAttribute('data-company-id');
    const source = form.getAttribute('data-source') || 'Theme form';

    if (!email || !listId || !companyId) {
      setMsg(form, 'something went wrong. try again.', 'error');
      return;
    }

    const nameField = form.querySelector('input[name="first_name"]');
    if (nameField && nameField.required && !firstName) {
      setMsg(form, 'please add your first name.', 'error');
      nameField.focus();
      return;
    }

    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    setMsg(form, 'sending…', null);

    const profileAttributes = { email: email };
    if (firstName) profileAttributes.first_name = firstName;

    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (res.ok) {
          form.reset();
          setMsg(form, 'you\u2019re on the list.', 'success');
        } else {
          return res.json().then(function (data) {
            const detail = (data && data.errors && data.errors[0] && data.errors[0].detail) || 'try again.';
            setMsg(form, detail.toLowerCase(), 'error');
          });
        }
      })
      .catch(function () {
        setMsg(form, 'network error. try again.', 'error');
      })
      .finally(function () {
        if (submit) submit.disabled = false;
      });
  });
})();
